import './App.scss';
import { useState, useEffect } from 'react';
import { HorizontalBar, Line } from '@reactchartjs/react-chart.js'
import numeral from "numeral"
import { NoCountry } from "./List"




function GetData({ Select_Country, Indicator, Data_Label, Order, height = "3000", Digit, Scale, Float = "1" }) {
    const [Data_countries, setData_countries] = useState([])
    const [Data_values, setData_values] = useState([])
    const [Current_Country, setCurrent_Country] = useState("United States")
    const [Current_Country_order, setCurrent_Country_order] = useState()
    const [Current_Country_value, setCurrent_Country_value] = useState()
    const [Current_Country_color, setCurrent_Country_color] = useState([])

    const getdata = async () => {
        const Data_countries_temp = []
        const Data_values_temp = []
        const Current_Country_color_temp = []

        const url = `https://api.worldbank.org/v2/country/all/indicator/${Indicator}?mrnev=1&per_page=500&format=json`
        const Req = await fetch(url)
        const Data = await Req.json()
        const sortedData = Data[1].sort((a, b) => (a.value > b.value ? -1 : 1))
        if (Order === "descending") {
            const sortedData = Data[1].sort((a, b) => (a.value > b.value ? -1 : 1))
        }

        if (Order === "ascending") {
            const sortedData = Data[1].sort((b, a) => (a.value > b.value ? -1 : 1))
        }

        sortedData.map(d => {
            // console.log("11111111111111------", Select_Country)
            if (!NoCountry.includes(d.country.value)) {
                // console.log("2222222222222222------", d.country.value)
                Data_countries_temp.push(d.country.value)
                Data_values_temp.push(d.value)
                if (d.country.value === Select_Country) {
                    setCurrent_Country_order(Data_values_temp.length)
                    // float === true
                    if (Float === "0") {
                        setCurrent_Country_value(Math.round(d.value * 100) / 100)
                    } else {
                        setCurrent_Country_value(numeral(d.value).format('0,0'))
                    }
                    Current_Country_color_temp.push("rgba(255, 247, 0, 0.653)")
                } else {
                    Current_Country_color_temp.push('#00ffd097')
                }
            }
        })
        setData_countries(Data_countries_temp)
        setData_values(Data_values_temp)
        setCurrent_Country_color(Current_Country_color_temp)
        // select country is not in API Data countries
        if (!Data_countries_temp.includes(Select_Country)) {
            setCurrent_Country_value("NoData")
            setCurrent_Country_order("Null")
        }
        // console.log("Data_countries_temp", Data_countries_temp)

    }



    useEffect(() => {
        getdata()
    }, [])

    if (Current_Country !== Select_Country) {
        getdata()
        setCurrent_Country(Select_Country)
    }

    const data = {
        labels: Data_countries,
        datasets: [
            {
                label: Data_Label,
                data: Data_values,
                backgroundColor:
                    Current_Country_color
                ,
                borderWidth: 1,
            },
        ],
    }


    const digit = Number(Digit)

    if (digit === 0) {
        var options = {
            responsive: true,
            legend: {
                display: false
            },
            scales: {
                xAxes: [{
                    position: "top",
                    gridLines: {
                        color: "rgba(255,255,255,0.2)"
                    },
                    ticks: {
                        callback: function (value) {
                            return numeral(value).format('0,0').slice(0)
                        },
                    }
                }],
                yAxes: [{
                    gridLines: {
                        color: "rgba(255,255,255,0.2)"
                    },

                    ticks: {
                        autoSkip: false,
                        callback: function (label, index, labels) {
                            return label.slice(0, 5);
                        }
                    }
                }],
            },
        }
    } else {
        var options = {
            responsive: true,
            legend: {
                display: false
            },
            scales: {
                xAxes: [{
                    position: "top",
                    gridLines: {
                        color: "rgba(255,255,255,0.2)"
                    },
                    ticks: {
                        callback: function (value) {
                            return numeral(value).format('0,0').slice(0, digit) + Scale
                        },
                    }
                }],
                yAxes: [{
                    gridLines: {
                        color: "rgba(255,255,255,0.2)"
                    },

                    ticks: {
                        autoSkip: false,
                        callback: function (label, index, labels) {
                            return label.slice(0, 5);
                        }
                    }
                }],
            },
        }
    }





    // ===============================================================================

    return (

        <div className="flex-row">
            <div className="box_con">
                <div className="flex-row_title">
                    <h2 className="flex-row_title_left">{Data_Label}</h2>
                    {/* <h2 className="flex-row_title_right">{Current_Country_value}</h2> */}
                </div>
                <div className="flex_info">
                    <p>{Current_Country_value}</p>
                    <p>{Current_Country_order} / {Data_countries.length} Countries</p>
                </div>
                <div className="box">
                    {/* <HorizontalBar data={data} options={options} height="5000" /> */}
                    <HorizontalBar data={data} options={options} height={height} />
                </div>
            </div>
        </div>


    );
}

export default GetData;

